<app-stages [stages]="stages" currentStage="Informacje podstawowe"></app-stages>
<br>
@if (!pending() && !loading()) {
  <form novalidate autocomplete="off" [formGroup]="form" (ngSubmit)="submitAndGoNext()">
    <div class="row">
      <div class="col-12">
        <p id="submissionPurposeDesc" class="pb-3">
          Cel złożenia wniosku *:
        </p>
        <div class="row">
          <div class="col-12">
            <div class="form-group" *ngIf='"submissionPurpose" as controlName'>
              @for (item of form.submissionPurposeOptions; track $index) {
                <div class="custom-radio custom-inline">
                  <input (change)="form.submissionPurposeChange(item)"
                         aria-labelledby="submissionPurposeDesc"
                         [name]="controlName"
                         [formControlName]='controlName'
                         type="radio"
                         [id]="controlName + $index"
                         [value]="item">
                  <label [for]="controlName + $index">
                    {{ item }}
                  </label>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
    <fieldset>
      <legend>
        Element powiązany z celem *:
      </legend>
      <div class="row">
        <div class="col-12">
          <app-alert alertTitle="Uwaga!" [closable]="false">
            Wymagane zaznaczenie przynajmniej <strong>1</strong> pozycji.
          </app-alert>
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                @if (form.alcoholUpTo45OnSite) {
                  <div class="mb-2" *ngIf="'alcoholUpTo45OnSite' as controlName">
                    <div class='custom-checkbox custom-inline'
                         [ngClass]='{ "is-invalid": form.showError(controlName) }'>
                      <input
                        [formControlName]='controlName'
                        type='checkbox'
                        [id]='controlName'
                        [name]='controlName'>
                      <label [for]='controlName'>
                        O zawartości do 4,5% alkoholu oraz na piwo przeznaczonych do spożycia w miejscu sprzedaży
                      </label>
                    </div>
                  </div>
                }
                <div class="mb-2" *ngIf="'alcoholUpTo45OffSite' as controlName">
                  <div class='custom-checkbox custom-inline' [ngClass]='{ "is-invalid": form.showError(controlName) }'>
                    <input
                      [formControlName]='controlName'
                      type='checkbox'
                      [id]='controlName'
                      [name]='controlName'>
                    <label [for]='controlName'>
                      @if (form.submissionPurpose.value === form.submissionPurposeOptions.at(2)) {
                        O zawartości do 4,5% alkoholu oraz na piwo
                      } @else {
                        O zawartości do 4,5% alkoholu oraz na piwo przeznaczonych do spożycia poza miejscem sprzedaży
                      }
                    </label>
                  </div>
                </div>
                @if (form.alcohol45To18OnSite) {
                  <div class="mb-2" *ngIf="'alcohol45To18OnSite' as controlName">
                    <div class='custom-checkbox custom-inline'
                         [ngClass]='{ "is-invalid": form.showError(controlName) }'>
                      <input
                        [formControlName]='controlName'
                        type='checkbox'
                        [id]='controlName'
                        [name]='controlName'>
                      <label [for]='controlName'>
                        O zawartości powyżej 4,5% do 18% alkoholu (z wyjątkiem piwa) przeznaczonych do spożycia w
                        miejscu
                        sprzedaży
                      </label>
                    </div>
                  </div>
                }
                <div class="mb-2" *ngIf="'alcohol45To18OffSite' as controlName">
                  <div class='custom-checkbox custom-inline' [ngClass]='{ "is-invalid": form.showError(controlName) }'>
                    <input
                      [formControlName]='controlName'
                      type='checkbox'
                      [id]='controlName'
                      [name]='controlName'>
                    <label [for]='controlName'>
                      @if (form.submissionPurpose.value === form.submissionPurposeOptions.at(2)) {
                        O zawartości powyżej 4,5% do 18% alkoholu (z wyjątkiem piwa)
                      } @else {
                        O zawartości powyżej 4,5% do 18% alkoholu (z wyjątkiem piwa) przeznaczonych do spożycia poza miejscem sprzedaży
                      }
                    </label>
                  </div>
                </div>
                @if (form.alcoholAbove18OnSite) {
                  <div class="mb-2" *ngIf="'alcoholAbove18OnSite' as controlName">
                    <div class='custom-checkbox custom-inline'
                         [ngClass]='{ "is-invalid": form.showError(controlName) }'>
                      <input
                        [formControlName]='controlName'
                        type='checkbox'
                        [id]='controlName'
                        [name]='controlName'>
                      <label [for]='controlName'>
                        O zawartości powyżej 18% alkoholu przeznaczonych do spożycia w miejscu sprzedaży
                      </label>
                    </div>
                  </div>
                }
                <div class="mb-2" *ngIf="'alcoholAbove18OffSite' as controlName">
                  <div class='custom-checkbox custom-inline' [ngClass]='{ "is-invalid": form.showError(controlName) }'>
                    <input
                      [formControlName]='controlName'
                      type='checkbox'
                      [id]='controlName'
                      [name]='controlName'>
                    <label [for]='controlName'>
                      @if (form.submissionPurpose.value === form.submissionPurposeOptions.at(2)) {
                        O zawartości powyżej 18% alkoholu
                      } @else {
                        O zawartości powyżej 18% alkoholu przeznaczonych do spożycia poza miejscem sprzedaży
                      }
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </fieldset>
    <fieldset>
      <legend>
        Informacje o imprezie
      </legend>
      <div class="row">
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"eventStartDate" as controlName'>
            <label [for]='controlName'>
              Termin imprezy od *
            </label>
            <app-date-picker [id]='controlName' [formControlName]='controlName'>
            </app-date-picker>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-4'>
          <div class='form-group' *ngIf='"eventEndDate" as controlName'>
            <label [for]='controlName'>
              Termin imprezy do *
            </label>
            <app-date-picker [id]='controlName' [formControlName]='controlName'>
            </app-date-picker>
            <app-validation-errors
              fieldLabel='Termin imprezy od'
              secondFieldLabel='terminie imprezy do'
              [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-8'>
          <div class='form-group' *ngIf='"eventName" as controlName'>
            <label [for]='controlName'>
              Nazwa *
            </label>
            <input
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu nazwę imprezy'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class='col-md-8'>
          <div class='form-group' *ngIf='"eventLocation" as controlName'>
            <label [for]='controlName'>
              Adres *
            </label>
            <input
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu adres imprezy'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    </fieldset>
    <fieldset>
      <legend class="mb-2">
        Adres/Adresy punktów sprzedaży
      </legend>
      <div class="row">
        <div class="col-md-10">
          <ul>
            <li>
              <div class="gov-card">
                <div class="gov-card__body pb-3">
                  <div class='form-group' *ngIf='"salesPointAddress1" as controlName'>
                    <label [for]='controlName'>
                      Adres punktu sprzedaży 1 *
                    </label>
                    <input
                      [id]='controlName'
                      [formControlName]='controlName'
                      [ngClass]='{ "is-invalid": form.showError(controlName) }'
                      placeholder='Wpisz tu adres punktu sprzedaży'
                      type='text'>
                    <app-validation-errors [control]='form.get(controlName)'>
                    </app-validation-errors>
                  </div>
                  <div class="col-12">
                    <div class='form-group' *ngIf='"storagePointAddress1" as controlName'>
                      <label [for]='controlName'>
                        Adres punktu składowania napojów alkoholowych (magazynu dystrybucyjnego) 1 *
                      </label>
                      <input
                        [id]='controlName'
                        [formControlName]='controlName'
                        [ngClass]='{ "is-invalid": form.showError(controlName) }'
                        placeholder='Wpisz tu adres składowania'
                        type='text'>
                      <app-validation-errors [control]='form.get(controlName)'>
                      </app-validation-errors>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <br>
            <li>
              <div class="gov-card">
                <div class="gov-card__body pb-3">
                  <div class='form-group' *ngIf='"salesPointAddress2" as controlName'>
                    <label [for]='controlName'>
                      Adres punktu sprzedaży 2
                    </label>
                    <input
                      [id]='controlName'
                      [formControlName]='controlName'
                      [ngClass]='{ "is-invalid": form.showError(controlName) }'
                      placeholder='Wpisz tu adres punktu sprzedaży'
                      type='text'>
                    <app-validation-errors [control]='form.get(controlName)'>
                    </app-validation-errors>
                  </div>
                  <div class="col-12">
                    <div class='form-group' *ngIf='"storagePointAddress2" as controlName'>
                      <label [for]='controlName'>
                        Adres punktu składowania napojów alkoholowych (magazynu dystrybucyjnego) 2
                      </label>
                      <input
                        [id]='controlName'
                        [formControlName]='controlName'
                        [ngClass]='{ "is-invalid": form.showError(controlName) }'
                        placeholder='Wpisz tu adres składowania'
                        type='text'>
                      <app-validation-errors [control]='form.get(controlName)'>
                      </app-validation-errors>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <br>
            <li>
              <div class="gov-card">
                <div class="gov-card__body pb-3">
                  <div class='form-group' *ngIf='"salesPointAddress3" as controlName'>
                    <label [for]='controlName'>
                      Adres punktu sprzedaży 3
                    </label>
                    <input
                      [id]='controlName'
                      [formControlName]='controlName'
                      [ngClass]='{ "is-invalid": form.showError(controlName) }'
                      placeholder='Wpisz tu adres punktu sprzedaży'
                      type='text'>
                    <app-validation-errors [control]='form.get(controlName)'>
                    </app-validation-errors>
                  </div>
                  <div class="col-12">
                    <div class='form-group' *ngIf='"storagePointAddress3" as controlName'>
                      <label [for]='controlName'>
                        Adres punktu składowania napojów alkoholowych (magazynu dystrybucyjnego) 3
                      </label>
                      <input
                        [id]='controlName'
                        [formControlName]='controlName'
                        [ngClass]='{ "is-invalid": form.showError(controlName) }'
                        placeholder='Wpisz tu adres składowania'
                        type='text'>
                      <app-validation-errors [control]='form.get(controlName)'>
                      </app-validation-errors>
                    </div>
                  </div>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </fieldset>
    <br>
    <fieldset>
      <legend>
        Przedmiot działalności gospodarczej
      </legend>
      <div class="row">
        <div class="col-md-10">
          <div class='form-group' *ngIf='"businessActivity1" as controlName'>
            <label [for]='controlName'>
              Przedmiot 1 *
            </label>
            <input
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu przedmiot'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class="col-md-10">
          <div class='form-group' *ngIf='"businessActivity2" as controlName'>
            <label [for]='controlName'>
              Przedmiot 2
            </label>
            <input
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu przedmiot'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class="col-md-10">
          <div class='form-group' *ngIf='"businessActivity3" as controlName'>
            <label [for]='controlName'>
              Przedmiot 3
            </label>
            <input
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu przedmiot'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class="col-md-10">
          <div class='form-group' *ngIf='"businessActivity4" as controlName'>
            <label [for]='controlName'>
              Przedmiot 4
            </label>
            <input
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu przedmiot'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
        <div class="col-md-10">
          <div class='form-group' *ngIf='"businessActivity5" as controlName'>
            <label [for]='controlName'>
              Przedmiot 5
            </label>
            <input
              [id]='controlName'
              [formControlName]='controlName'
              [ngClass]='{ "is-invalid": form.showError(controlName) }'
              placeholder='Wpisz tu przedmiot'
              type='text'>
            <app-validation-errors [control]='form.get(controlName)'>
            </app-validation-errors>
          </div>
        </div>
      </div>
    </fieldset>
    <div class='application-actions'>
      @if (!uiSettings()?.mobileEmbed) {
        <button
          type='button'
          class='btn btn-secondary'
          (click)='onCancel()'>
        <span>
          Wstecz
        </span>
        </button>
      }
      <button
        type='submit'
        class='btn btn-primary'>
        <span>Zapisz i przejdź dalej</span>
      </button>
    </div>
  </form>
} @else {
  <app-spinner>
    {{ pending() ? 'Poczekaj trwa zapisywania danych...' : 'Poczekaj trwa ładowanie danych...' }}
  </app-spinner>
}
